export default "skymp5-front/e8826512ccbece7a1ae9e0b5b6a2b1d0.gif";